import React, {useContext, useEffect, useState} from "react";
//import { ProfileContext } from "../ProfileContext";
import { errorMesg } from "../../../Toaster";
//import { ToastContainer } from 'react-toastify';
import { Modal, Button } from 'react-bootstrap';
import {getStages, getDispositionAPI, getSubDispositionAPI, AddRemarksAPI, getRemarksAPI} from "./../../../../API/Caller/LeadAPI";
import moment from "moment";

const Remarks = ({profiledata, pipelineReloadStatus, profileid}) =>{

    //const {profiledata, profileid, reloadPipeline} = useContext(ProfileContext);
    const [isremarksaddmodal, setIsRemarksAddModal] = useState(false);
    const [remarkslist, setRemarksList] = useState([]);
    const [stagelist, setStageList] = useState([]);
    const [dispositionlist, setDispositionList] = useState([]);
    const [subdispositionlist, setSubdispositionList] = useState([]);
    const [txtstage, setTxtStage] = useState("");
    const [txtdisposition, setTxtDisposition] = useState("");
    const [txtsubdisposition, setTxtSubdisposition] = useState("");
    const [scheduledate, setTxtScheduleDate] = useState("");
    const [scheduletime, setTxtScheduleTime] = useState("");
    const [txtremarks, setTxtRemarks] = useState("");
    const [btnrsubmitspin, setBtnRSubmitSpin] = useState(false);
    const [isremarksreload, setIsRemarksReload] = useState(false);

    const txtremarksmodalheader = "Add New Remarks";

    useEffect(()=>{
        setRemarksList(profiledata?.remarks || []);
    }, [profiledata]);

    useEffect(()=>{
        getStages(setStageList);
    }, []);

    useEffect(()=>{
        if(profileid)
        {
            getRemarksAPI(setRemarksList, profileid);
        }

        //pipelineReloadStatus(true);

    }, [profileid, isremarksreload]);

    // When remark added -> reload pipeline in parent
useEffect(() => {
    /*if (isremarksreload) 
    {*/
        pipelineReloadStatus();   // this toggles parent reload state
    //}
}, [isremarksreload]);

    /*useEffect(()=>{
        reloadPipeline();

    }, [isremarksreload, reloadPipeline]);*/

    const handleRemarksAddModal = () =>{
		setIsRemarksAddModal(!isremarksaddmodal);
	}

    const handleRemarksModalHide = () =>{
        setIsRemarksAddModal(false);
    }

    const handleSelectStage = (e) =>{
        setTxtStage(e.target.value);

        getDispositionAPI(e.target.value, setDispositionList);
    }

    const handleSelectDisposition = (e) =>{
        setTxtDisposition(e.target.value);

        getSubDispositionAPI(e.target.value, setSubdispositionList);
    }

    const handleSelectSubDisposition = (e) =>{
        setTxtSubdisposition(e.target.value);
    }

    const handleScheduleDate = (e) =>{
        setTxtScheduleDate(e.target.value);
    }

    const handleScheduleTime = (e) =>{
        setTxtScheduleTime(e.target.value);
    }

    const handleRemarks = (e) =>{
        setTxtRemarks(e.target.value);
    }

    const resetRemarksForm = () =>{

        setTxtStage("");
        setTxtDisposition("");
        setTxtSubdisposition("");
        setTxtScheduleDate("");
        setTxtScheduleTime("");
        setTxtRemarks("");
    }

    const handleAddRemarks = () =>{

        if(txtstage === "")
        {
            errorMesg("Please select stage");
            return;
        }
        else if(txtdisposition === "")
        {
            errorMesg("Please select disposition");
            return;
        }
        else if(txtsubdisposition === "")
        {
            errorMesg("Please select subdisposition");
            return;
        }
        else if(txtremarks === "")
        {
            errorMesg("Please enter remarks");
            return;
        }
        else if(txtremarks.length <= 15)
        {
            errorMesg("Remarks length should be greater than 15");
            return;
        }
        else
        {
            const formdata = new FormData();
            formdata.append('leadid', profileid);
            formdata.append('stageid', txtstage);
            formdata.append('dispositionid', txtdisposition);
            formdata.append('subdispositioniid', txtsubdisposition);
            formdata.append('notifydate', scheduledate);
            formdata.append('notifytime', scheduletime);
            formdata.append('txtremark', txtremarks);

            AddRemarksAPI(formdata, setBtnRSubmitSpin, setIsRemarksAddModal, () => setIsRemarksReload(prev => !prev), resetRemarksForm);
        }
    }

    if(!profiledata)
        return null;

    return(
    <div className="card">
        <div class="card remarks-timeline mb-30">
            <div class="title d-flex flex-wrap align-items-center justify-content-between mb-3">
                <div class="left">
                    <h6 class="text-medium mb-30">Latest Remarks</h6>
                </div>
                <div class="right">
                    <button className="btn btn-outline-warning" onClick={handleRemarksAddModal}>
                        <i className="fas fa-plus"></i> Add Remarks
                    </button>
                </div>
            </div>

            {remarkslist.length === 0 &&
                <p><center>No remarks found</center></p>
            }
            <ul class="timeline-3">
                {remarkslist && remarkslist.map(remark =>
                    (
                    <li key={remark.id}>
                        <span className="remark-heading">{remark.name}</span>
                        <span className="remark-date float-end">
                            {remark.created_at !== "" && remark.created_at !== null ?
                                (moment(remark.created_at).format('DD MMM YYYY'))
                            :
                                <></>
                            } 
                        </span>
                        <p class="mt-2">{remark.remarks}</p>
                    </li>
                    ))
                }
                
                {/*<li>
                    <span className="remark-heading">Shardha Sen</span>
                    <span className="remark-date float-end">20 March, 2014</span>
                    <p class="mt-2">No response, Mobile ringing, not picked</p>
                </li>*/}
            </ul>

        </div>

        <Modal show={isremarksaddmodal} onHide={handleRemarksModalHide} centered>
            <Modal.Header closeButton>
                <Modal.Title id="contained-modal-title-vcenter">{txtremarksmodalheader}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className="mb-3">
                    <label className="form-label">Lead Stage</label>
                    <select className="form-control" name="stages" id="stages" value={txtstage} onChange={handleSelectStage}>
                        <option value="">Select</option>
                        {stagelist && stagelist.length > 0 ?
                            (stagelist.map(stage =>
                                (
                                    <option value={stage.id} key={stage.id}>{stage.name}</option>
                                )
                            )

                            )
                        :
                            <></>    
                        }
                        
                    </select>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Disposition</label>
                            <select className="form-control" name="disposition" id="disposition" value={txtdisposition} onChange={handleSelectDisposition}>
                                <option value="">Select</option>
                                {dispositionlist && dispositionlist.length > 0 ?
                                    (dispositionlist.map(disposition =>
                                        (
                                            <option value={disposition.id} key={disposition.id}>{disposition.name}</option>
                                        )
                                    )

                                    )
                                :
                                    <></>    
                                }
                                
                            </select>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Reason</label>
                            <select className="form-control" name="subdisposition" id="subdisposition" value={txtsubdisposition} onChange={handleSelectSubDisposition}>
                                <option value="">Select</option>
                                {subdispositionlist && subdispositionlist.length > 0 ?
                                    (subdispositionlist.map(subdisp =>
                                        (
                                            <option value={subdisp.id} key={subdisp.id}>{subdisp.name}</option>
                                        )
                                    )

                                    )
                                :
                                    <></>    
                                }
                                
                            </select>
                        </div>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Schedule Date</label>
                            <input type="date" className="form-control" name="scheduledate" id="scheduledate" value={scheduledate} onChange={handleScheduleDate} />
                        </div>
                    </div>                            
                    <div className="col-md-6">
                        <div className="mb-3">
                            <label className="form-label">Schedule Time</label>
                            <input type="time" className="form-control" name="scheduletime" id="scheduletime" value={scheduletime} onChange={handleScheduleTime} />
                        </div>
                    </div>
                </div>
                <div className="mb-3">
                    <label className="form-label">Remarks</label>
                    <textarea className="form-control" name="remarks" id="remarks" cols="50" rows="5" onChange={handleRemarks}>{txtremarks}</textarea>

                </div>
            </Modal.Body>
            <Modal.Footer>
                <button type="button" class="btn btn-cancel" data-bs-dismiss="modal" onClick={handleRemarksModalHide}>Close</button>

                {btnrsubmitspin ?
                    <button type="button" class="btn btn-primary"> 
                        <div className="spinner-border" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </button>
                :
                    <button type="button" class="btn btn-primary" onClick={handleAddRemarks}> Add Remarks </button>
                }
            </Modal.Footer>
        </Modal>
    </div>
    );
}

export default Remarks;
